import { height } from "@fortawesome/free-regular-svg-icons/faAddressBook";
import React from "react";
import { Tooltip } from "react-bootstrap";
import { Area, AreaChart, Bar, BarChart, CartesianGrid, Legend, ReferenceLine, ResponsiveContainer, XAxis, YAxis } from "recharts";

const EmotionalLevelAreaChart = ({ data }) => {

    // #endregion

    const withPercent = data.map((item, index, arr) => ({
        ...item,
        percent: (index / (arr.length - 1)) * 100, // evenly distribute 0 → 100
    }));

    const gradientOffset = () => {
        const dataMax = Math.max(...data.map(i => i.uv));
        const dataMin = Math.min(...data.map(i => i.uv));

        if (dataMax <= 0) {
            return 0;
        }
        if (dataMin >= 0) {
            return 1;
        }

        return dataMax / (dataMax - dataMin);
    };

    const off = gradientOffset();
    const render = () => {
        if (data && data.length)
            return (
                <ResponsiveContainer width="100%" height="100%">
                    <AreaChart
                        data={withPercent}
                        margin={{ top: 20, right: 30, left: 20, bottom: 30 }}
                    >
                        <CartesianGrid strokeDasharray="2 2 " />
                        <XAxis
                            dataKey="percent"
                            type="number"
                            domain={[0, 100]}
                            ticks={[0, 20, 40, 60, 80, 100]}
                            tickFormatter={(tick) => `${tick}%`}
                            label={{
                                value: 'Narrative Progression',
                                dy: 30,
                                position: 'outsideBottom',
                                fill: '#888888',
                                fontSize: 12,
                            }} />
                        <YAxis
                            domain={['dataMin - 10', 'dataMax + 10']} // ✅ make sure it covers negative + positive
                            label={{
                                value: 'Success Factor (S)',
                                angle: -90,
                                dx: -20,
                                position: 'outsideLeft',
                                fill: '#888888',
                                fontSize: 12,
                            }}
                        />
                        <Tooltip />

                        {/* ✅ Gradient that changes color across the zero line */}
                        <defs>
                            <linearGradient id="splitColor" x1="0" y1="0" x2="0" y2="1">
                                <stop offset="0%" stopColor="orange" stopOpacity={1} />
                                <stop offset="50%" stopColor="orange" stopOpacity={0} />
                                <stop offset="100%" stopColor="orange" stopOpacity={1} />
                            </linearGradient>
                        </defs>

                        <Area
                            type="monotone"
                            dataKey="value"
                            stroke="orange"
                            strokeWidth={2}
                            fill="url(#splitColor)"
                        />
                        <ReferenceLine y={0} stroke="#999" strokeDasharray="5 5 " />
                    </AreaChart>
                </ResponsiveContainer>

            );

        return <p className="p-0 m-0 d-flex align-items-center justify-content-center">Loading...</p>;
    }
    return render();
}

export default EmotionalLevelAreaChart